<template>
  <div class="root _slide">
    <div :class="['inner', { 'page-width': !fullWidth}]">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Slide',
  props: {
    fullWidth: Boolean,
    horizontal: Boolean
  }
}
</script>

<style scoped lang="scss">
.root {
  font-size: 1rem;
}

._slide {
  height: 100vh;
  overflow-y: auto;
}

.inner {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  padding-top: $sz__site-header-height;
  padding-bottom: $sz__site-footer-height;
}
</style>
